"use client";

import { TextResources } from "@portal/assets/text/TextResources";
import { ToggleButton } from "@portal/components/atoms/buttons/toggle/ToggleButton";
import { InfoBoxComponent } from "@portal/components/atoms/infoBox";
import Typography from "@portal/components/atoms/v2/typography";
import Link from "next/link";
import { useState } from "react";

const ToogleRiskText = () => {
  const [showRiskText, setShowRiskText] = useState(false);

  return (
    <div>
      <ToggleButton
        activeText={TextResources.UNLISTED_SECURITIES_RISK_TITLE}
        inActiveText={TextResources.UNLISTED_SECURITIES_CLOSE_BUTTON}
        expanded={showRiskText}
        setExpanded={setShowRiskText}
      />
      {showRiskText && (
        <InfoBoxComponent>
          <div className="space-x-1">
            <Typography variant="BodySpan">{TextResources.UNLISTED_SECURITIES_RISK_TEXT}</Typography>
            <Link
              href="https://norne.no/wp-content/uploads/2023/11/Norne-Risiko-knyttet-til-finansielle-instrument.pdf"
              target="_blank"
              prefetch={false}
              className="text-blueHighlighted hover:underline"
            >
              <Typography variant="BodySpan">{TextResources.UNLISTED_SECURITIES_RISK_LINK_TEXT}</Typography>
            </Link>
          </div>
        </InfoBoxComponent>
      )}
    </div>
  );
};

export default ToogleRiskText;
